import { useEffect } from 'react'

import { Trans } from '@lingui/react'
import { TextButton } from '@twistopayments/design-system/components/atoms/button'
import {
  Headline,
  HeadlineIcon,
  HeadlineSubtitle,
  HeadlineTitle,
} from '@twistopayments/design-system/components/atoms/headline'
import { BigTwistoIcon } from '@twistopayments/design-system/icons/big'
import { useRouter } from 'next/router'

import { useCancelFlow } from '@twisto/flow-views/components'
import { ANALYTICS_EVENTS, analytics, events } from '@twisto/utils'

import type { OnModalClose } from '../flow-leave-confirm-modal'
import * as styles from '../flow-leave-confirm-modal.styles'

type Props = {
  onClose: OnModalClose
  stepName: string
  isOpened: boolean
}

export const OnboardingContent = ({ onClose, isOpened, stepName }: Props) => {
  const router = useRouter()
  const sessionId = router.query.sessionId as string
  const cancelFlow = useCancelFlow(sessionId)

  useEffect(() => {
    if (!isOpened) {
      return
    }

    analytics.logEvent(
      events[ANALYTICS_EVENTS.EXIT_SCREEN_VIEW]({
        step: stepName,
      })
    )
  }, [isOpened, stepName])

  return (
    <div css={styles.modalContent}>
      <Headline>
        <HeadlineIcon>
          <BigTwistoIcon
            color="secondaryMainContrast"
            height="100%"
            width="100%"
          />
        </HeadlineIcon>
        <HeadlineTitle>
          <Trans id="flow.leaveConfirmModal.onboarding.title" />
        </HeadlineTitle>
        <HeadlineSubtitle>
          <Trans id="flow.leaveConfirmModal.onboarding.subtitle" />
        </HeadlineSubtitle>
      </Headline>
      <div css={styles.modalContentButtons}>
        <TextButton color="secondary" onClick={() => onClose()}>
          <Trans id="flow.leaveConfirmModal.onboarding.button.stay" />
        </TextButton>
        <TextButton
          onClick={async () => {
            await cancelFlow()
            analytics.logEvent(
              events[ANALYTICS_EVENTS.EXIT_LEAVE_BUTTON_CLICK]({
                step: stepName,
              })
            )
            onClose({ skipAnalytics: true })
          }}
        >
          <Trans id="flow.leaveConfirmModal.onboarding.button.leave" />
        </TextButton>
      </div>
    </div>
  )
}
